import { QUESTION_TYPES, QUESTIONNAIRE_IMAGE_CSV_PLACEHOLDER } from './questionnaireTypes';

function parseAnswerPayload(value) {
  if (value === null || value === undefined || value === '') {
    return { empty: true };
  }
  if (typeof value === 'object') {
    return { empty: false, parsed: value };
  }
  if (typeof value === 'string') {
    try {
      return { empty: false, parsed: JSON.parse(value), raw: value };
    } catch {
      return { empty: false, raw: value };
    }
  }
  return { empty: false, raw: String(value) };
}

export function getQuestionnaireImagePreviewUrl(value) {
  const { empty, parsed } = parseAnswerPayload(value);
  if (empty || !parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return null;
  }
  return parsed.url || parsed.previewUrl || null;
}

export function getQuestionnaireImageMediaId(value) {
  const { empty, parsed } = parseAnswerPayload(value);
  if (empty || !parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return null;
  }
  const id = Number(parsed.id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function isQuestionnaireImageAnswer(answer) {
  const question = answer?.questionId || {};
  if (question.type === QUESTION_TYPES.image_upload) {
    return true;
  }
  const preview = getQuestionnaireImagePreviewUrl(answer?.value);
  if (preview) return true;
  const { parsed } = parseAnswerPayload(answer?.value);
  return Boolean(
    parsed && typeof parsed === 'object' && !Array.isArray(parsed) && parsed.id != null
  );
}

export function formatQuestionnaireAnswerValue(
  value,
  { forCsv = false, questionType = null } = {}
) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  if (questionType === QUESTION_TYPES.image_upload || getQuestionnaireImagePreviewUrl(value)) {
    return forCsv ? QUESTIONNAIRE_IMAGE_CSV_PLACEHOLDER : QUESTIONNAIRE_IMAGE_CSV_PLACEHOLDER;
  }

  const { empty, parsed, raw } = parseAnswerPayload(value);
  if (empty) return '-';

  if (parsed && typeof parsed === 'object') {
    if (Array.isArray(parsed)) {
      return parsed.join(', ');
    }
    if (parsed.id != null && (parsed.url || questionType === QUESTION_TYPES.image_upload)) {
      return QUESTIONNAIRE_IMAGE_CSV_PLACEHOLDER;
    }
    return JSON.stringify(parsed);
  }

  return String(raw ?? value);
}
